import { useEffect, useState } from 'react';

import { CatalogStarlinkType, PrismicCatalog, MLDCatalog } from 'domains/catalog';
import { StarlinkResponse } from 'domains/starlink';
import { getCatalogMldLinks, getCycleId } from 'helpers';
import { CardCatalogProps } from 'pages/Catalogs/components';
import { useGlobalContext } from 'store';

import { useCatalog } from './useCatalog';
import { useStarlinkContent } from './useStarlinkContent';

export type UseCurrentCatalogsType = {
  isLoading: boolean;
  isSuccess: boolean;
  data: CardCatalogProps[];
};

export const useCurrentCatalogs = (): UseCurrentCatalogsType => {
  const {
    data: starlinkData,
    isLoading: isLoadingStarlinkContent,
    isSuccess: isSuccessStarlinkContent,
  } = useStarlinkContent<CatalogStarlinkType>({
    document: 'collection_catalogs',
  });

  const {
    data: bffData,
    isLoading: isLoadingMLDCatalog,
    isSuccess: isSuccessMLDCatalog,
  } = useCatalog();

  const [currentCycleItems, setCurrentCycleItems] = useState<CardCatalogProps[]>([]);

  const starlinkContent =
    isSuccessStarlinkContent &&
    starlinkData &&
    ({ ...starlinkData?.items[0] } as StarlinkResponse<unknown, PrismicCatalog[]>);

  const { user } = useGlobalContext();

  const mldCatalogs = bffData?.length
    ? (bffData as MLDCatalog[])
    : (getCatalogMldLinks(user.resellerId, user.isMultiBrand).data as MLDCatalog[]);

  useEffect(() => {
    if (!isLoadingMLDCatalog && !isLoadingStarlinkContent) {
      setCurrentCycleItems([
        ...mldCatalogs
          .filter((catalog) => {
            return (
              Number(catalog?.cycleId) === user?.cycle?.currentCycle ||
              catalog.brand === 'MULTIMARCA' ||
              catalog.isFallback
            );
          })
          .map((catalog) => {
            const banner =
              starlinkContent && starlinkContent?.data?.catalogs
                ? starlinkContent?.data?.catalogs.find((item) => {
                    return (
                      item.brand?.toUpperCase() === catalog.brand?.toUpperCase() &&
                      getCycleId({ cycleYear: item.cycleYear, cycleNumber: item.cycleNumber }) ===
                        user?.cycle?.currentCycle
                    );
                  })?.banner?.url
                : null;
            return {
              ...catalog,
              banner,
            };
          }),
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingMLDCatalog, isLoadingStarlinkContent]);

  return {
    isLoading: isLoadingMLDCatalog || isLoadingStarlinkContent,
    isSuccess: isSuccessMLDCatalog || isSuccessStarlinkContent,
    data: currentCycleItems,
  };
};
